import { createContext } from "react";

import { AppointmentInformationModalHelper } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/appointment-information/AppointmentInformationModalHelper.ts";

export const AppointmentInformationModalContext =
  createContext<AppointmentInformationModalHelper>(
    {} as AppointmentInformationModalHelper
  );
